import { IVec3 } from "@base/math/Vec3";
import { PartialRecord, TupleToUnion } from "@base/util/TypeUtil";
import { IProductData, ShipmentType } from "@biz/definitions/ProductDefinitions";
import { Auto } from "@biz/definitions/SunSailDefinitions";
import { IClothItemData } from "@biz/logic/ClothData";

export const raffInstallationLocations = ["outdoor", "indoor"] as const;
export type RaffInstallationLocation = TupleToUnion<typeof raffInstallationLocations>;

export type RopeTensioningLengthType = "roundUp" | "exact";

// don't remove / add inbetween
export enum RaffType {
  None = -1,
  C,
  M_Rope,
  M_Guide,
  Count,
}

export type SCRaffType = "none" | "C" | "guide" | "rope"

// export function toSunSailTypeOld(raffType: RaffType): SunSailType {
//   switch (raffType) {
//     case RaffType.C:
//       return SunSailType.RaffC;
//     case RaffType.M_Guide:
//       return SunSailType.RaffM;
//     case RaffType.M_Rope:
//       return SunSailType.RaffM;
//   }
//   return SunSailType.None;
// }

export type RaffSailMountType = "profile" | "hemstitch";
export type RopeTensioningSystemType = "none" | "basic" | "premium";

export interface IRaffOverhang {
  left: number;
  right: number;
}

export interface IRaffFieldCalculation {
  type: RaffFieldCalculationType;
  individualFieldCount?: number;
  individualMaterialAdditionFactor?: number;

}

export interface IRaffPergola {
  enabled: boolean;
  rafterDirection: "x" | "z";
  rafterPosition: "top" | "bottom";
}

export interface IRaffDataSharedWithSC extends IProductData, IClothItemData {
  width: number;
  height: number;
  length: number;
  rollType?: "metal" | "plastic"; // for guides
  raffType: RaffType;
  sailMount?: RaffSailMountType;
  rainCut?: boolean;
  fieldCalculation: IRaffFieldCalculation
  articleSlots: PartialRecord<"motor" | "remoteReceiver" | "notch" | "preMontage" | "pulleySystem" | "pulleySystemRope" | "ropeMount" | "ropeSuspension", string>;
  shipment: ShipmentType;
  distIn1?: number;
  distIn2?: number;
  distInSidePriority?: number;
  ropeTensioningSystem?: RopeTensioningSystemType;
  ropeTensioningLengthType?: RopeTensioningLengthType;
  pergolaMaterial?: PergolaMaterial;
}

export type RaffRollType = "metal" | "plastic";
export type PergolaMaterial = "wood" | "metal";
export interface IRaffData extends IRaffDataSharedWithSC {
  itemType: "raff";
  installationLocation?: RaffInstallationLocation;

  ropeOverrideLength?: number[];
  pulleySystemRopeLength?: number;
  position: IVec3;
  rotationY: number;
  pergola: IRaffPergola,

  overhang?: IRaffOverhang;
  guidesCount: Auto<number>;
  angleX: number;
  angleZ: number;
}

export enum RaffFieldCalculationType {
  Standard,
  IndividualFields,
  AdditionalMaterial, // supported now within Standard and StandardWide
  StandardWide
}

export function getRaffFieldCalculationName(fieldCalculationType: RaffFieldCalculationType): string {

  switch (fieldCalculationType) {
    case RaffFieldCalculationType.Standard:
      return "Schmal";
    case RaffFieldCalculationType.StandardWide:
      return "Breit";
    case RaffFieldCalculationType.IndividualFields:
      return "Individuell";
    case RaffFieldCalculationType.AdditionalMaterial:
      return "Materialzugabe";
  }
  return "";
}

export type RaffFieldCutLayout = "along" | "across"; // along or across the roll

export interface IRaffPulleySystem {
  premium?: boolean;
  type: "single" | "double";
}

export const raffPulleySystems = {
  "00E13002066": { type: "single" },
  "00E13002067": { type: "single", premium: true },
  "00E13002068": { type: "double" },
  "00E13002069": { type: "double", premium: true },
} satisfies Record<string, IRaffPulleySystem>;

export type RaffPulleySystem = keyof typeof raffPulleySystems;